import React from 'react';
import AdotarCatalog from './AdotarCatalog';
import SEO from '../components/SEO';

const AdotarCaes: React.FC = () => (
  <>
    <SEO
      title="Cães para Adoção no Porto | Patinhas Sem Lar"
      description="Conheça cães disponíveis para adoção responsável através da Patinhas Sem Lar."
      path="/adotar/caes"
    />
    <AdotarCatalog
      kind="dog"
      chapter="Cap. II · Cães à espera"
      title="Os de quatro patas grandes."
      subtitle="Cada ficha é escrita à mão por quem cuida da rotina do cão. Carrega numa para conheceres a sua história."
    />
  </>
);

export default AdotarCaes;
